import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'

import {
  getIntegration,
  listAllIntegrations,
} from '@/gen/inventory/v1/integration_service-IntegrationService_connectquery'
import { IntegrationService } from '@/gen/inventory/v1/integration_service_pb'

import { defaultTransport } from '@/lib/connect/connect-transport'

export const getListAllIntegrationsQueryKey = () => {
  return createConnectQueryKey({
    schema: IntegrationService.method.listAllIntegrations,
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const getGetIntegrationQueryKey = (integrationId?: string) => {
  return createConnectQueryKey({
    schema: IntegrationService.method.getIntegration,
    input: integrationId ? { integrationId } : {},
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const useIntegrations = () => {
  const queryState = useQuery(listAllIntegrations)
  return {
    ...queryState,
    data: queryState.data?.integrations || [],
  }
}

export const useIntegration = ({
  integrationId,
  enabled = true,
  retry = 3,
}: {
  integrationId: string
  enabled?: boolean
  retry?: number
}) => {
  const queryState = useQuery(
    getIntegration,
    { integrationId },
    {
      enabled,
      retry,
    },
  )
  return {
    ...queryState,
    data: queryState.data?.integration,
  }
}
